// İSG uzmanı portalı — Risk editörü form tipleri (RHF/Zod). Oluştur editörü (inline tehlike
// kalemleri, useFieldArray) ile kalem modalı (tekil) ortak alan kümesini paylaşır.
//
// **⛔ score/level form modelinde YOKTUR (§19).** Form yalnız `probability`/`severity` (+ residual)
// tutar; kalıcı `score`/`level` sunucudan gelir. Matris seçici canlı rozeti bu değerlerden yalnız
// GÖSTERİM için türetir (deriveScore/deriveLevel) — API'ye gitmez.

import type { RiskItemWriteRequest } from '@isgportal/shared';

/** Tek tehlike kalemi form alanları (probability/severity 1-5; seçilmemişse null). */
export interface RiskItemFormValues {
  hazard: string;
  risk: string;
  affectedPersons: string;
  existingControls: string;
  /** Olasılık (1-5); matris seçilene dek null. */
  probability: number | null;
  /** Şiddet (1-5); matris seçilene dek null. */
  severity: number | null;
  recommendedControls: string;
  /** Artık olasılık (1-5) — residual ile birlikte doldurulur/temizlenir; null = yok. */
  residualProbability: number | null;
  /** Artık şiddet (1-5) — residual ile birlikte doldurulur/temizlenir; null = yok. */
  residualSeverity: number | null;
}

/** Oluştur editörü form değerleri (meta + inline tehlike kalemleri). */
export interface RiskEditorFormValues {
  title: string;
  siteUuid: string;
  area: string;
  /** `yyyy-MM-dd` (date input; submit'te UTC ISO'ya çevrilir). */
  assessmentDate: string;
  /** `yyyy-MM-dd` opsiyonel. */
  nextReviewDate: string;
  notes: string;
  items: RiskItemFormValues[];
}

/** Yeni boş tehlike kalemi (matris henüz seçilmemiş). */
export function emptyRiskItem(): RiskItemFormValues {
  return {
    hazard: '',
    risk: '',
    affectedPersons: '',
    existingControls: '',
    probability: null,
    severity: null,
    recommendedControls: '',
    residualProbability: null,
    residualSeverity: null,
  };
}

/** Boş/whitespace dizeyi `null`'a indirger (opsiyonel alanlar backend'e `null` gider). */
function nullable(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/**
 * Form kalemini API kalem yazma gövdesine (§19) çevirir. `probability`/`severity` matris
 * doğrulaması sonrası dolu kabul edilir. `score`/`level` **eklenmez** (sunucu türetir); residual
 * yalnız ikisi de doluysa gönderilir (aksi ikisi de `null`). `order` çağıran (index) verir.
 */
export function toRiskItemRequest(item: RiskItemFormValues, order?: number): RiskItemWriteRequest {
  const residualComplete = item.residualProbability != null && item.residualSeverity != null;
  return {
    hazard: item.hazard.trim(),
    risk: nullable(item.risk),
    affectedPersons: nullable(item.affectedPersons),
    existingControls: nullable(item.existingControls),
    probability: item.probability as number,
    severity: item.severity as number,
    recommendedControls: nullable(item.recommendedControls),
    residualProbability: residualComplete ? item.residualProbability : null,
    residualSeverity: residualComplete ? item.residualSeverity : null,
    ...(order != null ? { order } : {}),
  };
}
